/**
 * @readonly
 * @enum {string}
 */
export const Event = {
  CREATE_TOURNAMENT: "CREATE_TOURNAMENT",
  TOURNAMENTS_UPDATE: "TOURNAMENTS_UPDATE"
}
